<fury-page fxLayout="column" fxLayoutGap="24px">
  <h1 class="display-1">Bienvenue dans {{ appName }}</h1>
  <p class="description">Sélectionnez une section ci-dessous pour commencer.</p>

  <div class="dashboard-grid" fxLayout="row wrap" fxLayoutAlign="center" fxLayoutGap="24px grid">
    <div *ngFor="let item of items" fxFlex="1 1 calc(33.33% - 24px)" fxFlex.lt-md="1 1 calc(50% - 24px)" fxFlex.lt-sm="100%">
      <mat-card class="dashboard-card" [routerLink]="item.link">
        <div class="card-content">
          <div class="card-icon-container">
            <mat-icon color="primary">{{ item.icon }}</mat-icon>
          </div>
          <div class="card-text-container">
            <div class="mat-title">{{ item.title }}</div>
            <div class="mat-caption">{{ item.subtitle }}</div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</fury-page>
